'use client';

import { TrashIcon } from '@/_assets/icon-components';
import ConfirmModal from '@/_components/ConfirmModal';
import useGTM from '@/_hooks/useGTM';
import { CLEAR } from '@/_store/cart/cart.slice';
import { IRedux } from '@/_store/types';
import { useTranslations } from 'next-intl';
import dynamic from 'next/dynamic';
import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const UniversalHeader = dynamic(() => import('@/_components/Header'));

export default function Header({
  selectedShipperId,
}: {
  selectedShipperId: string;
}) {
  const cartState = useSelector((state: IRedux) => state.cart);
  const { data } = useSelector((state: IRedux) => state.settings);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const { sendGTM } = useGTM();
  const t = useTranslations();

  // Check if any brand has products
  const hasProducts = useMemo(() => {
    return cartState?.cart?.[selectedShipperId]?.products?.length > 0;
  }, [cartState?.cart, selectedShipperId]);

  const handleClear = () => {
    sendGTM('remove_from_cart', {
      cart: [],
      name: data?.data?.shipper_name,
    });

    // Clear all brands with products
    dispatch(CLEAR({ shipper_id: selectedShipperId }));
    setIsOpen(false);
  };

  return (
    <>
      <UniversalHeader
        title={t('cart')}
        icon={hasProducts && <TrashIcon color='var(--text-default)' />}
        backLink='/'
        onClick={() => setIsOpen(true)}
      />
      <ConfirmModal
        title={t('clear_cart')}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onConfirm={handleClear}
      />
    </>
  );
}
